// extracted by mini-css-extract-plugin
var _1 = "ZijFS_";
export { _1 as "spinner" }
